export default __webpack_public_path__ + "static/media/ic_user.7ac33782.svg";